import React, { useState, useRef, useEffect, useContext } from "react";

import { useHistory } from "react-router-dom";
// import { format } from "date-fns";
import openSocket from "socket.io-client";
import useSound from "use-sound";

import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';

import { i18n } from "../../translate/i18n";
import useChats from "../../hooks/useChats";
import alertSound from "../../assets/sound.mp3";
import { AuthContext } from "../../context/Auth/AuthContext";
import ChatListItem from "../ChatListItem";
import {format} from "date-fns";

const useStyles = makeStyles(theme => ({
	tabContainer: {
		overflowY: "auto",
		maxHeight: 350,
		...theme.scrollbarStyles,
	},
	popoverPaper: {
		width: "100%",
		maxWidth: 350,
		marginLeft: theme.spacing(2),
		marginRight: theme.spacing(1),
		[theme.breakpoints.down("sm")]: {
			maxWidth: 270,
		},
	},
	noShadow: {
		boxShadow: "none !important",
	},
}));

const NotificationsChatPopOver = () => {
	const classes = useStyles();

	const history = useHistory();
	const { user } = useContext(AuthContext);
	const ticketIdUrl = +history.location.pathname.split("/")[3];
	const ticketIdRef = useRef(ticketIdUrl);
	const anchorEl = useRef();
	const [isOpen, setIsOpen] = useState(false);
	const [notifications, setNotifications] = useState([]);

	const [, setDesktopNotifications] = useState([]);

	// const { tickets } = useTickets({ withUnreadMessages: "true" });
	const { tickets: chats } = useChats({ withUnreadMessages: "true" });
	// console.log(chats);
	const [play] = useSound(alertSound);
	const soundAlertRef = useRef();

	// const historyRef = useRef(history);

	useEffect(() => {
		soundAlertRef.current = play;

		/*if (!("Notification" in window)) {
			console.log("This browser doesn't support notifications");
		} else {
			Notification.requestPermission();
		}*/
	}, [play]);

	useEffect(() => {
		setNotifications(chats);
	}, [chats]);

	useEffect(() => {
		ticketIdRef.current = ticketIdUrl;
	}, [ticketIdUrl]);

	useEffect(() => {
		const socket = openSocket(window.env?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL, { auth: { token: localStorage.getItem("socketToken") }});

		socket.on("connect", () => socket.emit("joinNotification"));

		socket.on("chat", data => {
			if (data.action === "updateUnread" || data.action === "delete") {
				setNotifications(prevState => {
					const chatIndex = prevState.findIndex(t => t.id === data.chatId);
					if (chatIndex !== -1) {
						prevState.splice(chatIndex, 1);
						return [...prevState];
					}
					return prevState;
				});

				setDesktopNotifications(prevState => {
					const notfiticationIndex = prevState.findIndex(
						n => n.tag === String(data.chatId)
					);
					if (notfiticationIndex !== -1) {
						prevState[notfiticationIndex].close();
						prevState.splice(notfiticationIndex, 1);
						return [...prevState];
					}
					return prevState;
				});
			}
		});

		socket.on("unreadMessageChat", data => {
            if (data.action === "delete" && (data.chat.messagesUnread === 0 || (data.chat.isGroup && data.chat[`messagesUnreadBy${user?.id}`] === 0))) {
				setNotifications(prevState => {
					const ticketIndex = prevState.findIndex(t => t.id === data.chat.id);
					if (ticketIndex !== -1) {
						prevState.splice(ticketIndex, 1);
						return [...prevState];
					}
					return prevState;
				});

				setDesktopNotifications(prevState => {
					const notfiticationIndex = prevState.findIndex(
						n => n.tag === String(data.chat.id)
					);
					if (notfiticationIndex !== -1) {
						prevState[notfiticationIndex].close();
						prevState.splice(notfiticationIndex, 1);
						return [...prevState];
					}
					return prevState;
				});
			}
		})

		socket.on("appMessageChat", data => {
			if (
				data.action === "create" &&
				!data.message.read &&
				(data.chat.userId === user?.id || data.chat.callingUserId === user?.id || data.chat.users?.some(item => item.id === user?.id))
			) {
				// console.log(data.message)
				if (data.message.senderId !== user.id && (data.chat.messagesUnread > 0 || (data.chat.isGroup && data.chat[`messagesUnreadBy${user?.id}`] > 0))) {
					setNotifications(prevState => {
						const ticketIndex = prevState.findIndex(t => t.id === data.chat.id);
						if (ticketIndex !== -1) {
							prevState[ticketIndex] = data.chat;
							return [...prevState];
						}
						return [data.chat, ...prevState];
					});
				}

				const shouldNotNotificate =
					(data.message.chatId === ticketIdRef.current &&
						document.visibilityState === "visible") ||
					(data.chat.userId && data.chat.userId !== user?.id && data.chat.callingUserId !== user?.id);

				if (shouldNotNotificate) return;

				handleNotifications(data)
			}
		});

		return () => {
			socket.disconnect();
		};
		// eslint-disable-next-line
	}, [user]);

	const handleNotifications = data => {
		const { message, chat } = data;

		const userName = data.chat.userId === user?.id ? data.chat.callingUser?.name : data.chat.user?.name

		const options = {
			data: {
				title: `${i18n.t("tickets.notification.message")} ${userName}`,
				url: `${window.location.origin}/tickets/0/${chat.id}`
			},
			body: `${message.body} - ${format(new Date(), "HH:mm")}`,
			icon: "./144.png",
			tag: chat.id,
			renotify: true,
		};

		const notification = {};

		if (navigator.serviceWorker && navigator.serviceWorker.controller) {
			navigator.serviceWorker.controller.postMessage(options);
		} else {
			console.warn("Service Worker não está registrado ou ativo.");
		}

		setDesktopNotifications(prevState => {
			const notfiticationIndex = prevState.findIndex(
				n => n.tag === notification.tag
			);
			if (notfiticationIndex !== -1) {
				prevState[notfiticationIndex] = notification;
				return [...prevState];
			}
			return [notification, ...prevState];
		});

		soundAlertRef.current();
	};

	const handleClick = () => {
		setIsOpen(prevState => !prevState);
	};

	const handleClickAway = () => {
		setIsOpen(false);
	};

	const NotificationTicket = ({ children }) => {
		return <div onClick={handleClickAway}>{children}</div>;
	};

	return (
		<>
			<IconButton
				onClick={handleClick}
				ref={anchorEl}
				aria-label="Open Notifications"
				color="inherit"
			>
				<Badge overlap="rectangular" badgeContent={notifications.length} color="secondary">
					<RecordVoiceOverIcon />
				</Badge>
			</IconButton>
			<Popover
				disableScrollLock
				open={isOpen}
				anchorEl={anchorEl.current}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				classes={{ paper: classes.popoverPaper }}
				onClose={handleClickAway}
			>
				<List dense className={classes.tabContainer}>
					{notifications.length === 0 ? (
						<ListItem>
							<ListItemText>{i18n.t("notifications.noTickets")}</ListItemText>
						</ListItem>
					) : (
						notifications.map(ticket => (
							<NotificationTicket key={ticket.id}>
								<ChatListItem chat={ticket} />
							</NotificationTicket>
						))
					)}
				</List>
			</Popover>
		</>
	);
};

export default NotificationsChatPopOver;